import isTouchDevice from "./helpers/isTouchDevice";

export default function umeMenuInit() {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    const navbar = document.querySelector('header .navbar');
    const header = document.querySelector('header');
    let scrollHeight;
    const minificationBreakpoint = 90;

    let navbarCollapseBreakpoint = window.matchMedia("screen and (min-width: 1199px)");

    window.addEventListener('scroll', function () {
        const scrolledLogo = document.querySelector('.ume-primary-logo__scrolled');
        let globalTrue = scrolledLogo.classList.contains('ume-primary-logo__scrolled__global') ? true : false;
        const matches = navbarCollapseBreakpoint.matches ? navbarCollapseBreakpoint.matches : navbarCollapseBreakpoint.msMatchesSelector;

        if (matches && !globalTrue) {
            collapseNavbar(window.pageYOffset);
        }
    });


    function collapseNavbar(scrollY) {
        if (scrollY >= minificationBreakpoint && !navbar.classList.contains('minified')) {
            navbar.classList.add('minified');
            header.classList.add('minified');
        } else if (scrollY < minificationBreakpoint) {
            navbar.classList.remove('minified');
            header.classList.remove('minified');
        }
    }

    // expand navbar if focus is on global menu item
    document.addEventListener('focus', (ev) =>{

        if(ev.target.closest?.('#globalNavbarSupportedContent')){
            navbar.classList.remove('minified');
            header.classList.remove('minified');
        }
    }, true)


    document.addEventListener('click', function (ev) {
        if (!ev.target.closest('.navbar-toggler')) return;

        let clickedToggler = ev.target.closest('.navbar-toggler') ;

        let global = document.querySelector('.ume-global-menu-toggler');
        let main = document.querySelector('.ume-main-menu-toggler');
        if(clickedToggler.classList.contains('ume-global-menu-toggler') && main != null){
            let targetAttr = main.getAttribute('data-target');
            let target = document.querySelector(targetAttr);
            if(target.classList.contains('show')){
                target.classList.remove('show');
                main.classList.add('collapsed');
            }

        }
        if(clickedToggler.classList.contains('ume-main-menu-toggler') && global != null){
            let targetAttr = global.getAttribute('data-target');
            let target = document.querySelector(targetAttr);
            if(navbar.querySelector('.dropdown-menu.d-block')){
                let allSubSubDropdowns = navbar.querySelectorAll('.dropdown-menu.d-block');
                allSubSubDropdowns.forEach(dropdown => {
                    dropdown.classList.remove('d-block');
                })
            }

            if(target.classList.contains('show')){
                target.classList.remove('show');
            }

        }


    });
    let checkHover = wp_environment.menu_hover;
    jQuery(function ($) {
        if (vw >= 1199 && !isTouchDevice() && checkHover != 1) {

            const allFormerParents = document.querySelectorAll('.dropdown-item-former-parent');
            if(allFormerParents.length > 0){
                allFormerParents.forEach(p =>{
                    p.parentElement.removeChild(p);
                })
            }
            jQuery('.navbar .dropdown').hover(function () {
                jQuery(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();
                jQuery(this).find('.dropdown-toggle[data-toggle="dropdown"]').first().addClass('active').attr('aria-expanded', 'true')
                jQuery(this).addClass('show');
            }, function () {
                jQuery(this).find('.dropdown-menu').first().stop(true, true).delay(450).slideUp();
                jQuery(this).find('.dropdown-toggle[data-toggle="dropdown"]').first().removeClass('active').attr('aria-expanded', 'false')
                jQuery(this).removeClass('show')
            });
            jQuery('.navbar .ume-sub-sub-holder').hover(function () {
                jQuery(this).find('.dropdown-menu').first().stop(true, true).delay(200).slideDown();
                jQuery(this).find('.dropdown-item[data-toggle="dropdown"]').first().addClass('active').attr('aria-expanded', 'true')
            }, function () {
                jQuery(this).find('.dropdown-menu').first().stop(true, true).delay(200).slideUp();
                jQuery(this).find('.dropdown-item[data-toggle="dropdown"]').first().removeClass('active').attr('aria-expanded', 'false')
            });
            jQuery('.navbar .dropdown  a').click(function () {
                if(this.getAttribute('target')!== '_blank'){
                    location.href = this.href;
                }

            });

        }


    });

    jQuery(function ($) {
        if (vw >= 1199 && (isTouchDevice() || checkHover == 1 )) {
            document.addEventListener('click', ev => {
                if(!ev.target.classList.contains('dropdown-toggle')) return
                const container = ev.target.nextElementSibling;
                const subMenus = container.querySelectorAll('.ume-sub-sub-holder');
                if(subMenus.length > 0){
                    subMenus.forEach( subMenu => {
                        const target = subMenu.querySelector('.dropdown-menu__side');
                        target.classList.remove('show');
                    })
                }

            })
            const navbar = document.querySelector('.navbar-nav');
            const dropdowns = document.querySelectorAll('.dropdown-menu');
            if(dropdowns.length > 0){
                dropdowns.forEach(dropdown => {
                    if(!dropdown.querySelector('.dropdown-item-former-parent')){
                        const triggerLink = dropdown.previousElementSibling;
                        const subMenus = dropdown.querySelectorAll('.ume-sub-sub-holder');
                        if (triggerLink.getAttribute('href') !== '#' && triggerLink.getAttribute('href') !== '#!' && triggerLink.nodeName !== 'BUTTON') {
                            const insertLink = triggerLink.cloneNode(true);
                            insertLink.classList = 'dropdown-item dropdown-item-former-parent';
                            insertLink.setAttribute('data-toggle', '');
                            const overrideLabel = getDropdownOverrideLabel(triggerLink);
                            if (overrideLabel) insertLink.textContent = overrideLabel;
                            dropdown.insertBefore(insertLink, dropdown.firstChild);
                        }
                        if(subMenus.length > 0){
                            subMenus.forEach(subMenu => {
                                const link = subMenu.firstElementChild;
                                if(!link.getAttribute('data-ev-listener')){
                                    link.addEventListener('click', ev => {
                                        subMenus.forEach(m =>{
                                            if(subMenu !== m && !m.contains(subMenu)){
                                                let l = m.firstElementChild;
                                                m.classList.remove('show');
                                                let tC = l.nextElementSibling;
                                                tC.classList.remove('show');
                                            }

                                        })
                                        ev.stopPropagation();
                                        ev.preventDefault();
                                        const targetContainer = link.nextElementSibling;
                                        targetContainer.classList.toggle('show');
                                        subMenu.classList.toggle('show');
                                        document.addEventListener('click', ev => {
                                            if(ev.target == targetContainer) return;
                                            targetContainer.classList.remove('show');
                                            subMenu.classList.remove('show');

                                        });
                                    });
                                    link.setAttribute('data-ev-listener', 'true');
                                }

                            })
                        }
                    }


                })
            }


        }

    })
    jQuery(function ($) {
        if (vw < 1200) {
            const navbarToggle = document.querySelector('[data-target="#navbarSupportedContent"]');
            document.addEventListener('click', ev => {

                const matches = ev.target.matches ? ev.target.matches('.dropdown-item') : ev.target.msMatchesSelector('.dropdown-item');
                if (matches && ev.target.parentElement.classList.contains('dropdown-menu')) {
                    navbarToggle.click();
                } else return;
            });
            const mainMenuParent = document.getElementById('navbarSupportedContent');
            let mainMenuList = null;
            if(mainMenuParent !== null){
                mainMenuList = mainMenuParent.querySelector('.navbar-nav');
            }


            let parents = [];
            if (mainMenuList !== null) {
                parents = mainMenuList.querySelectorAll('.menu-item-has-children');
            }

            if (parents.length > 0) {
                parents.forEach(parent => {
                    const link = parent.querySelectorAll('.dropdown-toggle');
                    const dropdown = parent.querySelector('.dropdown-menu');
                    // sub top level parents
                    if(!dropdown.querySelector('.dropdown-item-former-parent')){
                        checkSubParents(dropdown);
                        if (link[0].getAttribute('href') === '#' || link[0].getAttribute('href') === '#!' || link[0].nodeName === 'BUTTON') return;
                        const newLink = link[0].cloneNode(true);
                        newLink.classList.add('dropdown-item');
                        newLink.classList.add('dropdown-item-special');
                        newLink.classList.add('dropdown-item-former-parent');
                        newLink.classList.remove('dropdown-toggle');
                        newLink.removeAttribute('data-toggle');
                        const overrideLabel = getDropdownOverrideLabel(link[0]);
                        if (overrideLabel) newLink.textContent = overrideLabel;
                        dropdown.insertBefore(newLink, dropdown.firstChild);
                    }



                })
            }


        }

    })

    function getDropdownOverrideLabel(sourceEl) {
        return sourceEl.getAttribute('data-dropdown-label') || wp_environment.menu_overview_label || '';
    }

    function checkSubParents(parentElement) {
        const subParents = parentElement.querySelectorAll('.ume-sub-sub-holder');
        if (subParents.length > 0) {
            subParents.forEach(parent => {
                const link = parent.querySelector('.dropdown-item');
                const dropdown = parent.querySelector('.dropdown-menu');
                if(!dropdown.querySelector('.dropdown-item-former-parent')){
                    if (link.getAttribute('href') !== '#' && link.getAttribute('href') !== '#!' && link.nodeName !== 'BUTTON') {
                        const newLink = link.cloneNode(link);
                        newLink.classList.add('dropdown-item-former-parent');
                        newLink.removeAttribute('data-toggle');
                        newLink.removeAttribute('aria-expanded');
                        const overrideLabel = getDropdownOverrideLabel(link);
                        if (overrideLabel) newLink.textContent = overrideLabel;
                        dropdown.insertBefore(newLink, dropdown.firstChild);
                    }
                    link.classList.add('dropdown-item-has-dropdown');
                    link.setAttribute('aria-expanded', 'false');
                    parent.addEventListener('click', ev => {
                        if (!ev.target.classList.contains('dropdown-item-has-dropdown')) return;
                        ev.preventDefault();
                        ev.stopPropagation();
                        dropdown.classList.toggle('d-block');
                        if(ev.target.classList.contains('active')){
                            ev.target.setAttribute('aria-expanded', 'false')
                        }else{
                            ev.target.setAttribute('aria-expanded', 'true')
                        }
                        ev.target.classList.toggle('active');
                    })
                }


            });
        }

    }

    // close mobile menu on link click (for anchor links)
    jQuery('#navbarSupportedContent>.navbar-nav>li>a').on('click', function () {
        if (!jQuery(this).hasClass('dropdown-toggle')) {
            jQuery('.navbar-collapse').collapse('hide');
        }

    });
    jQuery('#menu-ume-verbund>li>a').on('click', function () {
        jQuery('.navbar-collapse').collapse('hide');
    });
// Global Network Nav Toggle
    if (document.querySelector('.ume-global-menu')) {
        if (document.querySelector('.ume-global-network')) {

            const button = document.querySelector('.ume-global-network');
            let link = button.querySelector('button');
            if(link === null){
                link = button.querySelector('a');
            }
            const primaryLogo = document.querySelector('.ume-primary-logo');
            const scrolledLogo = document.querySelector('.ume-primary-logo__scrolled');
            const secondaryLogo = document.querySelector('.ume-secondary-logo');
            const nav = document.querySelector('.ume-global-nav-content-wrapper');
            const randomLink = nav.querySelector('button');
            const menuList = document.querySelector('.ume-global-menu-list ');
            button.addEventListener('click', (ev) => {
                ev.preventDefault();
                link.classList.toggle('active');
                nav.classList.toggle('ume-global-nav-content-wrapper__show');
                primaryLogo.classList.toggle('d-none');
                if (secondaryLogo != null) {
                    secondaryLogo.classList.toggle('ume-hide');
                }
                scrolledLogo.classList.toggle('ume-primary-logo__scrolled__global');
                menuList.classList.toggle('ume-no-border');
                randomLink.focus();
            });


        }

        document.addEventListener('click', ev => {

            const nav = document.querySelector('.ume-global-nav-content-wrapper');
            const button = document.querySelector('.ume-global-network');
            if (!ev.target.closest('.ume-global-network') && nav instanceof HTMLElement) {
                if (nav.classList.contains('ume-global-nav-content-wrapper__show') && !ev.target.closest('.ume-global-nav-content-wrapper__show')) {
                    button.click();
                }
            }


            if (ev.target.parentNode.classList.contains('ume-global-alert')) {
                let link = ev.target;
                if(link.href === wp_environment.home_url + '/#' || link.href === '#' || link.href === '#!' || link.nodeName === 'BUTTON'){
                    ev.preventDefault();
                    jQuery('#ume-info-modal').modal('show')
                }


            }
            if (ev.target.parentNode.classList.contains('ume-global-international')) {
                let link = ev.target;
                if(link.href === wp_environment.home_url + '/#' || link.href === '#' || link.href === '#!' || link.nodeName === 'BUTTON'){
                    ev.preventDefault();
                    jQuery('#ume-international-modal').modal('show')
                }


            }
            if (ev.target.parentNode.classList.contains('ume-global-emergency')) {
                let link = ev.target;
                if(link.href === wp_environment.home_url + '/#' || link.href === '#' || link.href === '#!' || link.nodeName === 'BUTTON'){
                    ev.preventDefault();
                    jQuery('#ume-notfall-modal').modal('show')
                }


            }
            if (ev.target.parentNode.classList.contains('ume-global-blood-donation')) {
                let link = ev.target;
                if(link.href === wp_environment.home_url + '/#' || link.href === '#' || link.href === '#!' || link.nodeName === 'BUTTON'){
                    ev.preventDefault();
                    jQuery('#ume-blutspende-modal').modal('show')
                }


            }
            if (ev.target.parentNode.classList.contains('ume-starter-simple-search-trigger') || ev.target.classList.contains('ume-starter-simple-search-trigger')) {


                    ev.preventDefault();
                    jQuery('.ume-starter-search-modal').modal('show')
            


            }
            const matches = ev.target.matches ? ev.target.matches('.ume-global-network-close') : ev.target.msMatchesSelector('.ume-global-network-close');
            if (matches || ev.target.classList.contains('ume-global-network-close-icon')) {
                ev.preventDefault();
                button.click();
            } else return;


        })
    }

}




